import { VideoResponsePlayback } from "@vericus/cadmus-common";
import { Modal, VisuallyHidden } from "@vericus/cadmus-ui";

import { create, useModal } from "@ebay/nice-modal-react";

interface VideoPreviewModalProps {
  videoUrl: string;
}

/**
 * Simple preview modal for the videos. Uses native HTML5 video player.
 */
export const VideoPreviewModal = create<VideoPreviewModalProps>((props) => {
  const modal = useModal();

  return (
    <Modal.Root
      open={modal.visible}
      onOpenChange={(open) => (open ? modal.show() : modal.hide())}
    >
      <Modal.Content width={800} withCloseButton>
        <VisuallyHidden.Root>
          <Modal.Title>Video Preview</Modal.Title>
        </VisuallyHidden.Root>
          <VideoResponsePlayback url={props.videoUrl} autoPlay />
      </Modal.Content>
    </Modal.Root>
  );
});
